// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2NUjK","inputWrap":"styles_inputWrap__3temH","input":"styles_input__3gHhW"};